import { createContext } from "react";

const TuitionFeesContext = createContext();

export default TuitionFeesContext;
